/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarcombo_None3Inputs */

const nl_enums_leerjaarcombo_none3 = /** @type {(inputs: Enums_Leerjaarcombo_None3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen groep`)
};

/**

* @param {Enums_Leerjaarcombo_None3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarcombo_none3 = /** @type {((inputs?: Enums_Leerjaarcombo_None3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarcombo_None3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarcombo_none3(inputs)
});
export { enums_leerjaarcombo_none3 as "enums.LeerjaarCombo.None" }